import * as types from '../actions/trainingAction';

const initialState = {
  restaurantUuid: null,
  startDate: null,
  endDate: null,
  timeInterval: null,
  timezone: null,
  eventName: 'all',
  status: 'all',
  show: 'all',
  limit: '20',
  page: 0,
  sortBy: 'eventTime',
  orderDirection: 'DESC',
  totalResults: 0,
  loading: false,
  scrollLoading: false,
  cursorDirection: 'FIRST',
  cursor: null,
  existNext: false,
  existPrevious: false,
  recordings: [],
};

const trainingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TRAINING_RECORDINGS: {
      return {
        ...state,
        loading: true,
      };
    }

    case types.GET_TRAINING_RECORDINGS_SUCCESS: {
      const preparedRecordings = action.payload.content.map(item => ({
        ...item,
        metadata: JSON.parse(item.metadata),
        preview: { image: null, loading: true, error: false },
        isDownloading: false,
        progress: 0,
        controller: null,
        childRecords: item.childRecords?.map(childRecord => ({
          ...childRecord,
          metadata: JSON.parse(childRecord.metadata),
          preview: { image: null, loading: true, error: false },
        })),
      }));
      return {
        ...state,
        loading: false,
        cursor: action.payload.cursor,
        cursorDirection: action.payload.cursorDirection,
        existNext: action.payload.existsNextPage,
        existPrevious: action.payload.existsPreviousPage,
        recordings:
          action.params.cursorDirection === 'NEXT'
            ? [...state.recordings, ...preparedRecordings]
            : preparedRecordings,
      };
    }

    case types.GET_TRAINING_RECORDINGS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }

    case types.SET_TRAINING_RECORDING_PREVIEW: {
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                preview: action.payload.preview,
              }
            : recording
        ),
      };
    }

    case types.SET_TRAINING_CHILD_RECORDING_PREVIEW: {
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.parentUuid
            ? {
                ...recording,
                childRecords: recording.childRecords.map(childRecord =>
                  childRecord.uuid === action.payload.childUuid
                    ? { ...childRecord, preview: action.payload.preview }
                    : childRecord
                ),
              }
            : recording
        ),
      };
    }

    case types.DOWNLOAD_TRAINING_RECORDING: {
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                isDownloading: true,
                progress: 0,
                controller: action.payload.controller,
              }
            : recording
        ),
      };
    }

    case types.DOWNLOAD_TRAINING_RECORDING_SUCCESS:
    case types.DOWNLOAD_TRAINING_RECORDING_ERROR: {
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                isDownloading: false,
                progress: 0,
                controller: null,
              }
            : recording
        ),
      };
    }

    case types.SET_TRAINING_RECORDING_PROGRESS: {
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                progress: action.payload.progress,
              }
            : recording
        ),
      };
    }

    case types.UPDATE_TRAINING_STATUS:
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.uuid
            ? { ...recording, isProcessed: action.payload.isProcessed }
            : recording
        ),
      };

    case types.UPDATE_TRAINING_COMMENTS:
      return {
        ...state,
        recordings: state.recordings.map(recording =>
          recording.uuid === action.payload.uuid
            ? { ...recording, commentsCount: action.payload.commentsCount }
            : recording
        ),
      };

    case types.CHANGE_TRAINING_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_TRAINING_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.RESET_TRAINING_STORE:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default trainingReducer;
